<template>
  <transition name="fade" @after-leave="handleAfterLeave">
    <div
      ref="alertwrap"
      :class="['alertwrap', type ? type : '']"
      v-show="visible"
      :style="positionStyle"
      @mouseenter="clearTimer"
      @mouseleave="startTimer"
    >
      <p>
        <i :class="['iconfont', iconClass]"></i>
        {{ message }}
      </p>
      <span class="alert-close" v-if="showClose" @click="close">
        <i class="iconfont icon-close"></i>
      </span>
    </div>
  </transition>
</template>

<script>
export default {
  name: "message",
  data() {
    return {
      visible: false,
      message: "",
      duration: 3000,
      type: "info",
      onClose: null,
      showClose: true,
      closed: false,
      verticalOffset: 70,
      timer: null,
    };
  },
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
      }
    },
  },
  computed: {
    iconClass() {
      let classer;
      switch (this.type) {
        case "info":
          classer = "icon-status-info";
          break;
        case "error":
          classer = "icon-status-fail";
          break;
        case "success":
          classer = "icon-status-succ";
          break;
        case "warning":
          classer = "icon-status-warn";
          break;
        default:
          classer = "icon-status-info";
          break;
      }
      return classer;
    },
    positionStyle() {
      return {
        top: `${this.verticalOffset}px`,
      };
    },
  },
  methods: {
    handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    close() {
      this.closed = true;
      if (typeof this.onClose === "function") {
        this.onClose(this);
      }
    },
    clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close();
          }
        }, this.duration);
      }
    },
  },
  mounted() {
    this.startTimer();
    setTimeout(() => {
      let originWidth = Math.ceil(
        window.getComputedStyle(this.$refs.alertwrap).width.slice(0, -2)
      );
      if (originWidth % 2 === 1) {
        this.$refs.alertwrap.style.width = `${originWidth + 1}px`;
      } else {
        this.$refs.alertwrap.style.width = `${originWidth}px`;
      }
    }, 20);
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.alertwrap {
  font-size: 16px;
  color: #333;
}
.alertwrap.success i {
  color: #3fb436;
}
.alertwrap.info i {
  color: #909399;
}
.alertwrap.warning i {
  color: #fbb91c;
}
.alertwrap.error i {
  color: #fa2c2c;
}

.alertwrap.warning .icon-status-warn {
  width: 16px;
  background: #fbb91c;
  height: 16px;
  display: block;
  border-radius: 50%;
  float: left;
  margin-top: 4px;
  position: relative;
  margin-right: 5px;
}
.alertwrap.warning .icon-status-warn:before {
  width: 3px;
  height: 6px;
  background: #fff;
  content: "";
  position: absolute;
  left: 50%;
  margin-left: -1.5px;
  top: 4px;
  border-radius: 2px;
}
.alertwrap.warning .icon-status-warn:after {
  width: 3px;
  height: 2px;
  display: block;
  background: #fff;
  content: "";
  position: absolute;
  left: 50%;
  margin-left: -1.5px;
  top: 12px;
  border-radius: 2px;
}
.alertwrap.warning i.icon-close {
  margin-right: 0;
}
@media (min-width: 768px) {
  .alertwrap {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    padding: 10px 15px;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 20px;
    display: block;
  }
}
@media only screen and (min-width: 480px) and (max-width: 768px) {
  .alertwrap {
    position: fixed;
    left: 16%;
    right: 16%;
    margin: auto;
    background: #fff;
    padding: 10px 15px;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 20px;
    display: block;
  }
}
@media (max-width: 480px) {
  .alertwrap {
    position: fixed;
    left: 10px;
    right: 10px;
    margin: auto;
    background: #fff;
    padding: 10px 15px;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 20px;
    display: block;
  }
}
.alertwrap .alert-close {
  width: 24px;
  height: 24px;
  text-align: center;
  display: block;
  float: right;
  line-height: 22px;
  cursor: pointer;
}
.alertwrap .alert-close .iconfont {
  font-size: 12px;
  color: #777;
}
.alertwrap .alert-close:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.alertwrap p {
  display: inline-block;
  padding-right: 20px;
  line-height: 24px;
}
</style>